
export const SET_SELECTED_VARS = 'SET_SELECTED_VARS';
export const SET_SELECTED_VAR_PROPS = 'SET_SELECTED_VAR_PROPS';
export const SET_SELECTED_COPY_VAR = 'SET_SELECTED_COPY_VAR';
export const COPY_SELECTED_VARS = 'COPY_SELECTED_VARS';
